"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullRateLimiter = void 0;
var tslib_1 = require("tslib");
var NullRateLimiter = /** @class */ (function () {
    function NullRateLimiter(_callback) {
        this._callback = _callback;
    }
    NullRateLimiter.prototype.request = function (req) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this._callback(req)];
            });
        });
    };
    return NullRateLimiter;
}());
exports.NullRateLimiter = NullRateLimiter;
//# sourceMappingURL=NullRateLimiter.js.map